document.addEventListener('DOMContentLoaded', () => {
  const estimatorContainers = document.querySelectorAll('[data-delivery-estimator]');

  if (estimatorContainers.length === 0) return;

  const STORAGE_KEY = 'shopify_delivery_pin';

  // --- API Mocks & Utilities ---

  const getCachedToken = () => {
    return localStorage.getItem('shopify_delivery_auth_token');
  };

  const setCachedToken = (token) => {
    localStorage.setItem('shopify_delivery_auth_token', token);
  };

  const getNewToken = async () => {
    try {
      const response = await fetch('https://v1thirdpartyapi.shpgodev.xyz/authToken', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          "username": "SGMU25102741241",
          "password": "Avp@200325"
        })
      });
      const data = await response.json();
      console.log('Token API Response:', data);
      
      const token = data.token || data.authToken || data.tokenKey || (data.data && data.data.token) || data.jwt;
      if (token) {
        setCachedToken(token);
        return token;
      }
      
      // Fallback: If no known key is found, search for any key containing a long string (typical of tokens)
      for (const key in data) {
        if (typeof data[key] === 'string' && data[key].length > 50) {
          setCachedToken(data[key]);
          return data[key];
        }
      }
      
      throw new Error('Token not found in response');
    } catch (error) {
      console.error('Failed to generate auth token:', error);
      throw error;
    }
  };

  const fetchDeliveryEstimate = async (pin) => {
    let token = getCachedToken();
    if (!token) {
      token = await getNewToken();
    }

    const makeRequest = async (authToken) => {
      return await fetch('https://v1thirdpartyapi.shpgodev.xyz/serviceAndRates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        body: JSON.stringify({
          "source": "562111",
          "destination": pin,
          "paymentType": "PPD",
          "weight": 1000,
          "length": 200,
          "breadth": 150,
          "height": 100
        })
      });
    };

    try {
      let response = await makeRequest(token);
      
      if (response.status === 401 || response.status === 403) {
        console.warn('Cached token expired or unauthorized. Fetching new token...');
        token = await getNewToken();
        response = await makeRequest(token);
      }

      let data = await response.json();

      // Check if body message indicates expired/invalid token
      if (data && (
        data.message === 'Token Expired' || 
        data.status === 'UNAUTHORIZED' || 
        data.error === 'Unauthorized' || 
        data.message === 'Invalid Token'
      )) {
        console.warn('API returned authorization/expiration error. Fetching new token...');
        token = await getNewToken();
        const retryRes = await makeRequest(token);
        data = await retryRes.json();
      }

      return data;
    } catch (error) {
      console.error('Delivery API Error, trying again with a fresh token:', error);
      try {
        token = await getNewToken();
        const retryRes = await makeRequest(token);
        return await retryRes.json();
      } catch (retryError) {
        console.error('Failed on retry with fresh token:', retryError);
        throw error;
      }
    }
  };

  const getPinFromCoordinates = async (lat, lon) => {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
      const data = await response.json();
      if (data && data.address && data.address.postcode) {
        // Ensure it's a 6 digit PIN (basic validation for India, adjust if needed)
        const pin = data.address.postcode.replace(/\s+/g, '');
        if (/^\d{6}$/.test(pin)) {
          return pin;
        }
      }
      return null;
    } catch (error) {
      console.error('Reverse geocoding failed:', error);
      return null;
    }
  };

  const fetchCityFromPin = async (pin) => {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
      const data = await res.json();
      if (data && data[0] && data[0].Status === 'Success' && data[0].PostOffice && data[0].PostOffice.length > 0) {
        return data[0].PostOffice[0].District || data[0].PostOffice[0].Block || data[0].PostOffice[0].State;
      }
    } catch (e) {
      console.error('Failed to fetch city name:', e);
    }
    return null;
  };

  // --- Component Logic ---

  estimatorContainers.forEach((container) => {
    const stateInput = container.querySelector('[data-state="input"]');
    const stateLoading = container.querySelector('[data-state="loading"]');
    const stateSuccess = container.querySelector('[data-state="success"]');
    const stateError = container.querySelector('[data-state="error"]');

    const inputField = container.querySelector('[data-pin-input]');
    const checkBtn = container.querySelector('[data-check-btn]');
    const changeBtn = container.querySelector('[data-change-btn]');
    const retryBtn = container.querySelector('[data-retry-btn]');

    const tatValue = container.querySelector('[data-tat-value]');
    const pinValue = container.querySelector('[data-pin-value]');
    const cityWrapper = container.querySelector('[data-city-wrapper]');
    const cityValue = container.querySelector('[data-city-value]');
    const courierWrapper = container.querySelector('[data-courier-wrapper]');
    const courierValue = container.querySelector('[data-courier-value]');
    const errorMsg = container.querySelector('[data-error-msg]');

    let isChecking = false;

    const setState = (stateName) => {
      [stateInput, stateLoading, stateSuccess, stateError].forEach(el => el.classList.add('hidden'));
      if (stateName === 'input') stateInput.classList.remove('hidden');
      if (stateName === 'loading') stateLoading.classList.remove('hidden');
      if (stateName === 'success') stateSuccess.classList.remove('hidden');
      if (stateName === 'error') stateError.classList.remove('hidden');
    };

    const handleCheckDelivery = async (pin) => {
      if (isChecking) return;

      if (!/^\d{6}$/.test(pin)) {
        showError('Please enter a valid 6 digit PIN code.');
        return;
      }

      isChecking = true;
      setState('loading');
      inputField.disabled = true;
      checkBtn.disabled = true;

      try {
        const response = await fetchDeliveryEstimate(pin);
        console.log('Delivery Estimator API Response:', response);

        const isSuccess = response && (
          (typeof response.status === 'string' && response.status.toUpperCase() === 'SUCCESS') ||
          response.success === true ||
          (response.priceData && response.priceData.length > 0)
        );

        if (isSuccess && response.priceData && response.priceData.length > 0) {
          // Parse all TAT values
          const tats = response.priceData
            .map(item => {
              const parsed = parseInt(String(item.tat).replace(/[^0-9]/g, ''), 10);
              return isNaN(parsed) ? null : parsed;
            })
            .filter(t => t !== null);

          // Find the courier with the minimum tat for fallback & courier display
          const bestOption = response.priceData.reduce((min, current) => {
            return (current.tat < min.tat) ? current : min;
          }, response.priceData[0]);

          console.group('Courier Delivery Estimations');
          response.priceData.forEach(item => {
            const courierName = item.courierName || item.courier_name || item.name || item.courier || 'Unknown Courier';
            console.log(`${courierName}: ${item.tat} Days`);
          });
          
          console.groupEnd();

          if (tats.length > 0) {
            const minTat = Math.min(...tats);
            const maxTat = Math.max(...tats);
            tatValue.textContent = (minTat === maxTat) ? `${minTat}` : `${minTat}-${maxTat}`;
          } else {
            tatValue.textContent = bestOption.tat;
          }

          pinValue.textContent = pin;

          if (cityWrapper && cityValue) {
            cityWrapper.classList.add('hidden');
            const cachedCity = localStorage.getItem(STORAGE_KEY + '_city_' + pin);
            if (cachedCity) {
              cityValue.textContent = cachedCity;
              cityWrapper.classList.remove('hidden');
            } else {
              fetchCityFromPin(pin).then(city => {
                if (city) {
                  cityValue.textContent = city;
                  cityWrapper.classList.remove('hidden');
                  localStorage.setItem(STORAGE_KEY + '_city_' + pin, city);
                }
              });
            }
          }

          if (courierWrapper && courierValue) {
            if (bestOption.courierName) {
              courierValue.textContent = bestOption.courierName;
              courierWrapper.classList.remove('hidden');
            } else {
              courierWrapper.classList.add('hidden');
            }
          }

          localStorage.setItem(STORAGE_KEY, pin);
          setState('success');
        } else {
          showError('Delivery is currently unavailable for this location.');
        }
      } catch (error) {
        showError(error.message || 'Unable to check delivery. Please try again.');
      } finally {
        isChecking = false;
        inputField.disabled = false;
        checkBtn.disabled = false;
      }
    };

    const showError = (message) => {
      errorMsg.textContent = message;
      setState('error');
    };

    const resetUI = () => {
      localStorage.removeItem(STORAGE_KEY);
      inputField.value = '';
      setState('input');
      inputField.focus();
    };

    // Event Listeners
    checkBtn.addEventListener('click', () => {
      handleCheckDelivery(inputField.value.trim());
    });

    changeBtn.addEventListener('click', resetUI);
    retryBtn.addEventListener('click', resetUI);

    inputField.addEventListener('input', (e) => {
      // Only allow numbers
      e.target.value = e.target.value.replace(/[^0-9]/g, '');

      // Auto-trigger when 6 digits are entered
      if (e.target.value.length === 6) {
        // debounce slightly for better UX
        setTimeout(() => {
          handleCheckDelivery(e.target.value);
        }, 300);
      }
    });

    inputField.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleCheckDelivery(inputField.value.trim());
      }
    });

    // Initialization Flow
    const init = async () => {
      const savedPin = localStorage.getItem(STORAGE_KEY);

      if (savedPin && /^\d{6}$/.test(savedPin)) {
        const savedCity = localStorage.getItem(STORAGE_KEY + '_city_' + savedPin);
        if (savedCity && cityWrapper && cityValue) {
          cityValue.textContent = savedCity;
          cityWrapper.classList.remove('hidden');
        }
        // Step 1: Use saved PIN
        handleCheckDelivery(savedPin);
      } else {
        // Step 2 & 3: Attempt Geolocation (Commented out per request)
        /*
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const { latitude, longitude } = position.coords;
              const detectedPin = await getPinFromCoordinates(latitude, longitude);
              if (detectedPin) {
                handleCheckDelivery(detectedPin);
              }
            },
            (error) => {
              // Location denied or unavailable, do nothing, UI stays in input state
              console.log('Location detection unavailable:', error.message);
            },
            { timeout: 5000 }
          );
        }
        */
      }
    };

    init();
  });
});
